import { Injectable } from '@angular/core';
import { FieldAgentClient, GetTemplateOrderLinesRequest, Order } from 'ep-bt-field-agent-proxy';
import { EpbtFieldAgentService } from './epbt-field-agent.service';
import { DocumentTypes, ModelType, GridFieldType, BistrackConfig } from 'ep-bt-controls';
import { IEpBtFaCardModel } from '../models/epbt-fa-card.model';
import { DocumentDetailModel } from '../models/document-detail.model';
import { EpbtFaPurchaseOrderLines } from '../models/epbt-fa-purchase-order-lines';

@Injectable({
    providedIn: 'root'
})
export class EpbtFaDocumentDetailService {
    gridColumns: any[];
    cardColumns: IEpBtFaCardModel[];
    bistrackSettings: any;
    webTrackUser: any;
    documentDetail: DocumentDetailModel;
    totalMarginFlag = true;
    totalCostFlag = true;
    public selectedWorkOrderItem: any;

    constructor(private client: FieldAgentClient, private faService: EpbtFieldAgentService, private config: BistrackConfig) {
        // this.bistrackSettings = this.faService.getBisTrackSetting();
        this.faService.getBisTrackSetting((bistrackSettings: any) => {
            this.bistrackSettings = bistrackSettings;
        });

        this.faService.getWebTrackUser((webTrackUser: any) => {
            this.webTrackUser = webTrackUser;
        });

    }

    generateGridModelIEpGridColumn(documentType: string, modelType: string): any {
        this.gridColumns = [];
        this.cardColumns = [];
        switch (documentType) {
            case DocumentTypes.Opportunities:
                break;
            case DocumentTypes.Quotes:
                ModelType.GridModel == modelType ? this.generateGridModelForQuotesAndOrders(DocumentTypes.Quotes) : this.generateCardModelForQuotesAndOrders(DocumentTypes.Quotes);
                break;
            case DocumentTypes.Orders:
                ModelType.GridModel == modelType ? this.generateGridModelForQuotesAndOrders(DocumentTypes.Orders) : this.generateCardModelForQuotesAndOrders(DocumentTypes.Orders);
                break;
            case DocumentTypes.TemplateOrders:
                ModelType.GridModel == modelType ? this.generateGridModelForQuotesAndOrders(DocumentTypes.TemplateOrders) : this.generateCardModelForQuotesAndOrders(DocumentTypes.TemplateOrders);
                break;
            case DocumentTypes.CallOffOrders:
                ModelType.GridModel == modelType ? this.generateGridModelForCallofforders(DocumentTypes.CallOffOrders) : this.generateCardModelForCallofforders(DocumentTypes.CallOffOrders);
                break;
            case DocumentTypes.Invoices:
                ModelType.GridModel == modelType ? this.generateGridModelForInvoiceAndCredit(DocumentTypes.Invoices) : this.generateCardModelForInvoiceAndCredit(DocumentTypes.Invoices);
                break;
            case DocumentTypes.Credits:
                ModelType.GridModel == modelType ? this.generateGridModelForInvoiceAndCredit(DocumentTypes.Credits) : this.generateCardModelForInvoiceAndCredit(DocumentTypes.Credits);
                break;
            case DocumentTypes.ProductOrders:
                ModelType.GridModel == modelType ? this.generateGridModelForProductPurchasedBy(DocumentTypes.ProductOrders) : this.generateCardModelForProductPurchasedBy(DocumentTypes.ProductOrders);
                break;
            case DocumentTypes.Stocktransfers:
                ModelType.GridModel == modelType ? this.generateGridModelForStocktransfers(DocumentTypes.Stocktransfers) : this.generateCardModelForStocktransfers(DocumentTypes.Stocktransfers);
                break;
            case DocumentTypes.PurchaseOrder:
                ModelType.GridModel == modelType ? this.generateGridModelForPurchaseOrders(DocumentTypes.PurchaseOrder) : this.generateCardModelForPurchaseOrders(DocumentTypes.PurchaseOrder);
                break;
            // case DocumentTypes.WorkOrders:
            //   {
            //     ModelType.GridModel == modelType ? this.generateGridModelForStocktransfers(DocumentTypes.WorkOrders) : this.generateCardModelForStocktransfers(DocumentTypes.WorkOrders);
            //     break;
            //   }
            default:
                break;
        }
        return ModelType.GridModel == modelType ? this.gridColumns : this.cardColumns;
    }


    // Types Quote, Order, CallOff,

    getDetailsFromApi(documentType: string, selectedItem: any, subscribe: (selectedItem: any) => void) {
        switch (documentType) {
            case DocumentTypes.Opportunities:
                    break;
            case DocumentTypes.Quotes:
                    try {
                        this.client.getQuoteDetail(selectedItem.orderId).subscribe(res => {
                            subscribe(this.getDetailsModelForQuotes(selectedItem, res));
                        });
                    } catch (ex) {
                        console.log('getQuotesRequest Error :-');
                        console.log(ex);
                    }
                    break;
            case DocumentTypes.Orders:
                    try {
                        this.client.getOrderDetail(selectedItem.orderId).subscribe(res => {
                            subscribe(this.getDetailsModelForOrders(selectedItem, res));
                        });
                    } catch (ex) {
                        console.log('getOrdersRequest Error :-');
                        console.log(ex);
                    }
                    break;
            case DocumentTypes.TemplateOrders:
                    // getDetailsModelForTemplateOrders
                    try {
                        const req = new GetTemplateOrderLinesRequest();
                        req.orderId = selectedItem.orderId;
                        this.client.getTemplateOrderLines(req).subscribe(res => {
                            subscribe(this.getDetailsModelForTemplateOrders(selectedItem, res));
                        });
                    } catch (ex) {
                        console.log('getTemplateOrdersRequest Error :-');
                        console.log(ex);
                    }
                    break;
            case DocumentTypes.CallOffOrders:
                    try {
                        this.client.getOrderDetail(selectedItem.orderID).subscribe(res => {
                            subscribe(this.getDetailsModelForCallofforder(selectedItem, res));
                        });
                    } catch (ex) {
                        console.log('getOrdersRequest Error :-');
                        console.log(ex);
                    }
                    break;
            case DocumentTypes.Invoices:
                    try {
                        this.client.getInvoiceDetail(selectedItem.invoiceId).subscribe(res => {
                            subscribe(this.getDetailsModelForInvoiceAndCredit('Invoice', selectedItem, res));
                        });
                    } catch (ex) {
                        console.log('getInvoicesRequest Error :-');
                        console.log(ex);
                    }
                    break;
            case DocumentTypes.Credits:
                    try {
                        this.client.getCreditNoteDetail(selectedItem.creditNoteId).subscribe(res => {
                            subscribe(this.getDetailsModelForInvoiceAndCredit('Credit', selectedItem, res));
                        });
                    } catch (ex) {
                        console.log('getCreditsRequest Error :-');
                        console.log(ex);
                    }
                    break;
            case DocumentTypes.ProductOrders:
                    try {
                        this.client.getOrderDetail(selectedItem.orderId).subscribe(res => {
                            subscribe(this.getDetailsModelForProduct(selectedItem, res));
                        });
                    } catch (ex) {
                        console.log('getQuotesRequest Error :-');
                        console.log(ex);
                    }
                    break;
            case DocumentTypes.Stocktransfers:
                    try {
                        this.client.getOrderDetail(selectedItem.orderId).subscribe(res => {
                            subscribe(this.getDetailsModelForStock(selectedItem, res));
                        });
                    } catch (ex) {
                        console.log('geStockRequest Error :-');
                        console.log(ex);
                    }
                    break;
            case DocumentTypes.PurchaseOrder:
                    try {
                        this.client.getPurchaseOrderLines(selectedItem.purchaseOrderID).subscribe(res => {
                            subscribe(this.getDetailsModelForPurchase(selectedItem, res));
                            console.log(JSON.stringify(res), 'etails purchased order status');
                        });
                    } catch (ex) {
                        console.log('getPurchaseordersRequest Error :-');
                        console.log(ex);
                    }
                    break;
            default:
                    break;
        }
        return '';
    }

    // Quotes Start
    getDetailsModelForQuotes(selectedItem: any, selectedItemDetails: any): DocumentDetailModel {
        this.documentDetail = new DocumentDetailModel();
        this.documentDetail.type = 'Quote';
        this.documentDetail.title = selectedItem.quoteNumber;
        this.documentDetail.id = selectedItem.orderId;
        this.documentDetail.customerID = selectedItem.customerID;
        this.documentDetail.customerCode = selectedItem.customerCode;
        this.documentDetail.name = selectedItem.name;
        this.documentDetail.status = selectedItem.orderStatus;
        this.documentDetail.statusName = selectedItem.orderStatusName;
        this.documentDetail.jobRef = selectedItem.jobRef;
        this.documentDetail.expiryDate = selectedItem.expiryDate;
        this.documentDetail.createdDate = selectedItem.dateCreated;
        this.documentDetail.requiredDate = selectedItem.dateRequired;
        this.documentDetail.branchID = selectedItem.branchID;
        this.documentDetail.branchName = selectedItem.branchName;
        this.documentDetail.currencyCode = selectedItem.currencyCode;
        this.documentDetail.goodsTotal = selectedItem.goodsTotal;
        this.documentDetail.vatTax = selectedItem.vatTax;
        this.documentDetail.totalAmount = selectedItem.totalAmount;
        this.documentDetail.totalMargin = selectedItemDetails.totalMargin;
        this.documentDetail.totalCost = selectedItemDetails.totalCost;
        this.documentDetail.specOrder = selectedItemDetails.hasSpecialProducts;
        this.documentDetail.specOrderDesc = selectedItemDetails.hasSpecialProductsDescription;
        this.documentDetail.noOfLines = selectedItem.noOfLines;
        this.documentDetail.salesRepName = selectedItem.salesRepName;
        this.documentDetail.contactName = selectedItemDetails.contactName;
        this.documentDetail.contactNumber = selectedItemDetails.contactNumber;
        this.documentDetail.deliveryAddressCode = selectedItem.deliveryAddressCode;
        this.documentDetail.deliveryAddress = selectedItemDetails.deliveryAddress;
        this.documentDetail.invoiceAddressCode = selectedItem.invoiceAddressCode;
        this.documentDetail.invoiceAddress = selectedItemDetails.invoiceAddress;
        this.documentDetail.lines = selectedItemDetails.lines;
        return this.documentDetail;
    }

    acceptQuote(currentItem: any, subscribe: (selectedItem: any) => void) {
        try {
            this.client.acceptQuote(currentItem.id, this.config.getLoggedinUser(), currentItem.branchID).subscribe(res => {
                if (res) {

                    this.client.getOrder(this.webTrackUser, res).subscribe(documentsRes => {
                        if (documentsRes) {
                            subscribe(documentsRes);
                        } else {
                            const bistrackUser = this.webTrackUser;
                            bistrackUser.customerID = currentItem.customerID;
                            this.client.getQuote(bistrackUser, currentItem.id).subscribe(selectedQuote => {
                                this.client.getQuoteDetail(currentItem.id).subscribe(res => {
                                    subscribe(this.getDetailsModelForQuotes(selectedQuote, res));
                                });
                            });
                        }
                    });
                    // subscribe(res);
                }
                //         else
                // this.client.getQuote()
            });
        } catch (ex) {
            console.log('getInvoicesRequest Error :-');
            console.log(ex);
        }
    }
    // Quotes End

    // Orders Start
    getDetailsModelForOrders(selectedItem: any, selectedItemDetails: any): DocumentDetailModel {
        this.documentDetail = new DocumentDetailModel();
        this.documentDetail.type = 'Order';
        this.documentDetail.title = selectedItem.orderNumber;
        this.documentDetail.id = selectedItem.orderId;
        this.documentDetail.customerID = selectedItem.customerID;
        this.documentDetail.customerCode = selectedItem.customerCode;
        this.documentDetail.name = selectedItem.name;
        this.documentDetail.status = selectedItem.orderStatus;
        this.documentDetail.statusName = selectedItem.orderStatus;
        this.documentDetail.jobRef = selectedItem.jobRef;
        // this.documentDetail.expiryDate = selectedItem.expiryDate;
        this.documentDetail.createdDate = selectedItemDetails.dateTimeCreated;
        this.documentDetail.requiredDate = selectedItem.dateRequired;
        this.documentDetail.branchID = selectedItem.branchId;
        this.documentDetail.branchName = selectedItem.branchName;
        this.documentDetail.currencyCode = selectedItemDetails.currencyCode;
        this.documentDetail.goodsTotal = selectedItem.totalSellPrice;
        this.documentDetail.vatTax = selectedItem.totalVat;
        this.documentDetail.totalAmount = selectedItem.totalAmount;
        this.documentDetail.totalMargin = selectedItemDetails.totalMargin;
        this.documentDetail.totalCost = selectedItemDetails.totalCost;
        // this.documentDetail.specOrder = selectedItemDetails.hasSpecialProducts;
        // this.documentDetail.specOrderDesc = selectedItemDetails.hasSpecialProductsDescription;
        this.documentDetail.noOfLines = selectedItem.noOfLines;
        this.documentDetail.salesRepName = selectedItem.salesRepName;
        this.documentDetail.contactName = selectedItemDetails.contactName;
        this.documentDetail.contactNumber = selectedItemDetails.contactNumber;
        this.documentDetail.deliveryAddressCode = selectedItemDetails.deliveryAddressCode;
        this.documentDetail.deliveryAddress = selectedItemDetails.deliveryAddress;
        this.documentDetail.invoiceAddressCode = selectedItemDetails.invoiceAddressCode;
        this.documentDetail.invoiceAddress = selectedItemDetails.invoiceAddress;
        this.documentDetail.lines = selectedItemDetails.lines;
        return this.documentDetail;
    }
    // Orders End

    // Orders Start
    getDetailsModelForTemplateOrders(selectedItem: any, selectedItemDetails: any): DocumentDetailModel {
        this.documentDetail = new DocumentDetailModel();
        this.documentDetail.type = 'TemplateOrder';
        this.documentDetail.title = selectedItem.orderNumber;
        this.documentDetail.id = selectedItem.orderId;
        this.documentDetail.customerCode = selectedItem.customerCode;
        this.documentDetail.name = selectedItem.name;
        this.documentDetail.description = selectedItem.description;
        this.documentDetail.jobRef = selectedItem.jobRef;
        this.documentDetail.createdDate = selectedItem.expiryDate;
        this.documentDetail.branchName = selectedItem.branchName;
        this.documentDetail.currencyCode = selectedItem.currencyCode;

        this.documentDetail.goodsTotal = selectedItem.goodsTotal;
        this.documentDetail.vatTax = selectedItem.vatOrTax;
        this.documentDetail.totalAmount = selectedItem.totalAmount;
        this.documentDetail.totalMargin = selectedItem.totalMargin;
        this.documentDetail.totalCost = selectedItem.totalCost;
        this.documentDetail.noOfLines = selectedItem.lines;

        this.documentDetail.salesRepName = selectedItem.salesRepName;
        this.documentDetail.contactName = selectedItem.contactName;
        this.documentDetail.contactNumber = selectedItem.contactNumber;

        this.documentDetail.deliveryAddressCode = selectedItem.deliveryAddressCode;
        this.documentDetail.deliveryAddress = selectedItem.deliveryAddress;

        this.documentDetail.invoiceAddressCode = selectedItem.invoiceAddressCode;
        this.documentDetail.invoiceAddress = selectedItem.invoiceAddress;
        this.documentDetail.lines = selectedItemDetails;
        return this.documentDetail;
    }

    getOrder(orderId: number, subscribe: (selectedItem: Order) => void) {
        this.client.getOrder(this.webTrackUser, orderId).subscribe(order => {
            subscribe(order);
        });
    }

    recalculatePaymentOutstanding(orderId: number, clearCOD: boolean, subscribe: (selectedItem: boolean) => void) {
        try {
            this.client.recalculatePaymentOutstanding(orderId, clearCOD).subscribe(order => {
                subscribe(true);
            });
        } catch (ex) {
            subscribe(false);
        }
    }
    // Orders End



    // CALLOFFORDER MODEL(MAPPING) START

    getDetailsModelForCallofforder(selectedItem: any, selectedItemDetails: any): DocumentDetailModel {
        this.documentDetail = new DocumentDetailModel();
        this.documentDetail.type = 'CallOff';
        this.documentDetail.title = selectedItem.orderNumber;
        this.documentDetail.id = selectedItem.orderID;
        this.documentDetail.customerID = selectedItem.customerID;
        this.documentDetail.customerCode = selectedItem.customerCode;
        this.documentDetail.name = selectedItem.name;

        this.documentDetail.statusName = selectedItem.orderStatus;
        this.documentDetail.description = selectedItem.description;
        this.documentDetail.jobRef = selectedItem.jobRef;

        this.documentDetail.createdDate = selectedItem.dateCreated;
        this.documentDetail.requiredDate = selectedItem.dateRequired;
        this.documentDetail.expiryDate = selectedItem.expiryDate;

        this.documentDetail.branchID = selectedItem.branchId;
        this.documentDetail.branchName = selectedItem.branchName;
        this.documentDetail.currencyCode = selectedItem.currencyCode;

        this.documentDetail.goodsTotal = selectedItem.totalSellPriceInCurrency;
        this.documentDetail.vatTax = selectedItem.totalTaxInCurrency;
        this.documentDetail.totalAmount = selectedItem.totalAmount;
        this.documentDetail.totalMargin = selectedItem.totalMargin;
        this.documentDetail.totalCost = selectedItem.totalCostPrice;
        // this.documentDetail.specOrder = selectedItemDetails.hasSpecialProducts;
        // this.documentDetail.specOrderDesc = selectedItemDetails.hasSpecialProductsDescription;
        this.documentDetail.noOfLines = selectedItem.noOfLines;
        this.documentDetail.salesRepName = selectedItem.salesRepName;
        this.documentDetail.contactName = selectedItem.contactName;
        this.documentDetail.contactNumber = selectedItem.contactNumber;
        this.documentDetail.deliveryAddressCode = selectedItem.deliveryAddress.addressCode;
        this.documentDetail.deliveryAddress = this.getAddressData(selectedItem.deliveryAddress);
        this.documentDetail.invoiceAddressCode = selectedItem.invoiceAddress.addressCode;
        this.documentDetail.invoiceAddress = this.getAddressData(selectedItem.invoiceAddress);
        this.documentDetail.lines = selectedItemDetails.lines;
        return this.documentDetail;
    }

    // CALLOFFORDER MODEL(MAPPING) END

    // address field mapping start

    getAddressData(addressObj: any) {
        let address = '';
        // (addressObj.addressId) ? address += addressObj.addressId : '';
        // (addressObj.addressCode) ? address += ', ' + addressObj.addressCode : '';
        (addressObj.address1) ? address += addressObj.address1 : '';
        (addressObj.city) ? address += ', ' + addressObj.address2 : '';
        (addressObj.city) ? address += ', ' + addressObj.city : '';
        (addressObj.county) ? address += ', ' + addressObj.county : '';
        (addressObj.postCode) ? address += ', ' + addressObj.postCode : '';
        (addressObj.country) ? address += ', ' + addressObj.country : '';
        return address;
    }

    // address field mapping end







    // Invoice and Credit Start
    getDetailsModelForInvoiceAndCredit(type: any, selectedItem: any, selectedItemDetails: any): DocumentDetailModel {
        this.documentDetail = new DocumentDetailModel();
        this.documentDetail.type = type;
        this.documentDetail.title = selectedItem.name;
        this.documentDetail.id = selectedItem.invoiceId;
        this.documentDetail.customerID = selectedItem.customerID;
        this.documentDetail.customerCode = selectedItem.customerCode;
        this.documentDetail.name = selectedItem.name;
        this.documentDetail.jobRef = selectedItem.jobRef;
        this.documentDetail.createdDate = selectedItem.orderDate;
        if (type == 'Invoice') {
            this.documentDetail.statusName = selectedItem.invoiceStatus;
            this.documentDetail.invoiceDate = selectedItem.invoiceDate;
            this.documentDetail.dueDate = selectedItem.dueDate;
        } else {
            // Credit
            this.documentDetail.creditDate = selectedItem.creditDate;
            this.documentDetail.statusName = selectedItem.creditNoteStatus;
        }
        this.documentDetail.branchID = selectedItem.branchId;
        this.documentDetail.branchName = selectedItem.branchName;
        this.documentDetail.currencyCode = selectedItem.currencyCode;
        this.documentDetail.goodsTotal = selectedItem.goodsTotal;
        this.documentDetail.vatTax = selectedItem.vatTax;
        this.documentDetail.totalAmount = selectedItem.totalAmount;
        this.documentDetail.totalMargin = selectedItem.totalMargin;
        this.documentDetail.totalCost = selectedItem.totalCost;
        this.documentDetail.noOfLines = selectedItem.noOfLines;
        if (type == 'Invoice') {
            this.documentDetail.contactName = selectedItemDetails.contactName;
            this.documentDetail.contactNumber = selectedItemDetails.contactNumber;
            this.documentDetail.invoiceAddressCode = selectedItemDetails.invoiceAddressCode;
            this.documentDetail.invoiceAddress = selectedItemDetails.invoiceAddress;
            this.documentDetail.deliveryAddressCode = selectedItemDetails.deliveryAddressCode;
            this.documentDetail.deliveryAddress = selectedItemDetails.deliveryAddress;
        } else {
            // Credit
            this.documentDetail.contactName = selectedItem.contactName;
            this.documentDetail.contactNumber = selectedItem.contactNumber;
            this.documentDetail.invoiceAddressCode = selectedItem.creditNoteAddressCode;
            this.documentDetail.invoiceAddress = selectedItemDetails.creditNoteAddress; // creditNoteAddress
            this.documentDetail.deliveryAddressCode = selectedItem.deliveryAddressCode;
            this.documentDetail.deliveryAddress = selectedItemDetails.deliveryAddress; // deliveryAddress
        }
        this.documentDetail.lines = selectedItemDetails.lines;
        return this.documentDetail;
    }
    // Invoice and Credit


    // PRODUCT MODEL(MAPPING) START


    getDetailsModelForProduct(selectedItem: any, selectedItemDetails: any): DocumentDetailModel {
        this.documentDetail = new DocumentDetailModel();
        this.documentDetail.type = 'Order';
        this.documentDetail.title = selectedItem.orderNumber;
        this.documentDetail.id = selectedItem.orderId;
        this.documentDetail.customerID = selectedItem.customer.customerId;
        this.documentDetail.customerCode = selectedItem.customer.customerCode;
        this.documentDetail.customerName = selectedItem.customer.name;
        this.documentDetail.name = selectedItem.customer.name;
        this.documentDetail.status = selectedItem.orderStatus;
        this.documentDetail.statusName = selectedItemDetails.orderStatus;
        this.documentDetail.jobRef = selectedItem.jobReference;
        // this.documentDetail.expiryDate = selectedItem.expiryDate;
        this.documentDetail.createdDate = selectedItemDetails.dateTimeCreated;
        this.documentDetail.requiredDate = selectedItemDetails.dateRequired;
        this.documentDetail.branchID = selectedItem.branch.branchID;
        this.documentDetail.branchName = selectedItem.branch.name;
        this.documentDetail.currencyCode = selectedItemDetails.currencyCode;
        this.documentDetail.goodsTotal = selectedItemDetails.totalSellPrice;
        this.documentDetail.vatTax = selectedItemDetails.totalVat;
        this.documentDetail.totalAmount = selectedItemDetails.totalAmount;
        this.documentDetail.totalMargin = selectedItemDetails.totalMargin;
        this.documentDetail.totalCost = selectedItemDetails.totalCost;
        // this.documentDetail.specOrder = selectedItemDetails.hasSpecialProducts;
        // this.documentDetail.specOrderDesc = selectedItemDetails.hasSpecialProductsDescription;
        this.documentDetail.noOfLines = selectedItemDetails.noOfLines;
        this.documentDetail.salesRepName = selectedItemDetails.salesRepName;
        this.documentDetail.contactName = selectedItemDetails.contactName;
        this.documentDetail.contactNumber = selectedItemDetails.contactNumber;
        this.documentDetail.deliveryAddressCode = selectedItemDetails.deliveryAddressCode;
        this.documentDetail.deliveryAddress = selectedItemDetails.deliveryAddress;
        this.documentDetail.invoiceAddressCode = selectedItemDetails.invoiceAddressCode;
        this.documentDetail.invoiceAddress = selectedItemDetails.invoiceAddress;
        this.documentDetail.lines = selectedItemDetails.lines;
        return this.documentDetail;
    }

    generateGridModelForQuotesAndOrders(type: string) {
        this.gridColumns = [
            { field: type == DocumentTypes.TemplateOrders ? 'productDescription' : 'description', title: 'Description', width: 30, hidden: false },
            { field: 'productCode', title: 'Prod. Code', width: 30, hidden: false },
            { field: 'lineNumber', title: 'Line', width: 30, hidden: false },
            { field: 'quantity', title: 'Quantity', width: 30, hidden: false, editor: 'numeric', type: GridFieldType.NumericWithCode }];

        if (type == DocumentTypes.TemplateOrders || type == DocumentTypes.Orders) {
            this.gridColumns.push({ field: 'quantityTally', title: 'Tally', width: 30, hidden: false });
        }

        this.gridColumns.push({
            field: type == DocumentTypes.TemplateOrders ? 'sellingPrice' : 'unitSellPrice',
            title: 'Sell price',
            width: 30,
            hidden: false,
            editor: 'numeric',
            type: GridFieldType.CurrencyWithCode },
            { field: type == DocumentTypes.Quotes ? 'totalPrice' : 'totalSellPrice', title: 'Total price', width: 30, hidden: false, editor: 'numeric', type: GridFieldType.Currency });

        if (this.totalMarginFlag) {
            this.gridColumns.push({ field: 'totalMargin', title: 'Total margin', width: 30, hidden: false, editor: 'numeric', type: GridFieldType.Percentage });
        }

        if (this.totalCostFlag) {
            this.gridColumns.push({ field: 'totalCost', title: 'Total cost', width: 30, hidden: false, editor: 'numeric', type: GridFieldType.Currency });
        }

        if (type == DocumentTypes.Quotes) {
            this.gridColumns.push({ field: 'specialOrderFlag', title: 'Spec. order', width: 30, hidden: false });
        }
    }

    generateCardModelForQuotesAndOrders(type: string) {
        this.cardColumns = [
            { field: type == DocumentTypes.TemplateOrders ? 'productDescription' : 'description', isTitle: true, displayName: '', icon: '' },
            { field: 'productCode', displayName: 'Prod. Code', icon: '' },
            { field: 'lineNumber', displayName: 'Line', icon: '' },
            { field: 'quantity', displayName: 'Quantity', icon: '', isNumericWithCode: true }];

        if (type == DocumentTypes.TemplateOrders) {
            this.cardColumns.push({ field: 'quantityTally', displayName: 'Tally', icon: '' });
        }

        this.cardColumns.push({ field: type == DocumentTypes.TemplateOrders ? 'sellingPrice' : 'unitSellPrice', displayName: 'Sell price', icon: '', isCurrencyWithCode: true },
            { field: type == DocumentTypes.Quotes ? 'totalPrice' : 'totalSellPrice', displayName: 'Total price', icon: '', isCurrency: true });

        if (this.totalMarginFlag) {
            this.cardColumns.push({ field: 'totalMargin', displayName: 'Total margin', icon: '', isPercentage: true });
        }

        if (this.totalCostFlag) {
            this.cardColumns.push({ field: 'totalCost', displayName: 'Total cost', icon: '', isCurrency: true });
        }

        if (type == DocumentTypes.Quotes) {
            this.cardColumns.push({ field: 'specialOrderFlag', displayName: 'Spec. order', icon: '' });
        }
    }

    // generateGridModelForTemplateOrders(type: string) {
    //     this.gridColumns = [
    //         { field: type == DocumentTypes.TemplateOrders ? 'productDescription' : 'description', title: 'Description', width: 30, hidden: false },
    //         { field: 'productCode', title: 'Prod. Code', width: 30, hidden: false },
    //         { field: 'lineNumber', title: 'Line', width: 30, hidden: false },
    //         { field: 'quantity', title: 'Quantity', width: 30, hidden: false, editor: 'numeric', type: GridFieldType.NumericWithCode },
    //         { field: type == DocumentTypes.TemplateOrders ? 'sellingPrice' : 'unitSellPrice', title: 'Sell price', width: 30, hidden: false,
    //           editor: 'numeric', type: GridFieldType.CurrencyWithCode },
    //         { field: type == DocumentTypes.Quotes ? 'totalPrice' : 'totalSellPrice', title: 'Total price', width: 30, hidden: false, editor: 'numeric', type: GridFieldType.Currency },
    //         { field: 'quantityTally', title: 'Tally', width: 30, hidden: false },
    //         { field: 'totalMargin', title: 'Total margin', width: 30, hidden: false, editor: 'numeric', type: GridFieldType.Percentage },
    //         { field: 'totalCost', title: 'Total cost', width: 30, hidden: false, editor: 'numeric', type: GridFieldType.Currency }
    //     ];

    //     if (type == DocumentTypes.Quotes) {
    //         this.gridColumns.push({ field: 'specialOrderFlag', title: 'Spec. order', width: 30, hidden: false });
    //     }
    // }

    // generateCardModelForTemplateOrders(type: string) {
    //     this.cardColumns = [
    //         { field: type == DocumentTypes.TemplateOrders ? "productDescription" : "description", isTitle: true, displayName: "", icon: "" },
    //         { field: "productCode", displayName: "Prod. Code", icon: "" },
    //         { field: "lineNumber", displayName: "Line", icon: "" },
    //         { field: "quantity", displayName: "Quantity", icon: "", isNumericWithCode: true },
    //         { field: type == DocumentTypes.TemplateOrders ? "sellingPrice" : "unitSellPrice", displayName: "Sell price", icon: "", isCurrencyWithCode: true },
    //         { field: type == DocumentTypes.Quotes ? 'totalPrice' : 'totalSellPrice', displayName: "Total price", icon: "", isCurrency: true },
    //         { field: "quantityTally", displayName: "Tally", icon: "" },
    //         { field: "totalMargin", displayName: "Total margin", icon: "", isPercentage: true },
    //         { field: "totalCost", displayName: "Total cost", icon: "", isCurrency: true }
    //     ];
    //     if (type == DocumentTypes.Quotes) {
    //         this.cardColumns.push({ field: "specialOrderFlag", displayName: "Spec. order", icon: "" });
    //     }
    // }



    // CALLOFFORDER GRID START
    generateGridModelForCallofforders(type: string) {
        this.gridColumns = [
            { field: 'description', title: 'Description', width: 30, hidden: false },
            { field: 'productCode', title: 'Prod. Code', width: 30, hidden: false },
            { field: 'lineNumber', title: 'Line', width: 30, hidden: false },
            { field: 'quantity', title: 'Quantity', width: 30, hidden: false, editor: 'numeric', type: GridFieldType.NumericWithCode },
            { field: 'quantityCalledOff', title: 'Called off', width: 30, hidden: false, editor: 'numeric', type: GridFieldType.NumericWithCode },
            { field: 'unitSellPrice', title: 'Sell price', width: 30, hidden: false, editor: 'numeric', type: GridFieldType.CurrencyWithCode },
            { field: 'totalSellPrice', title: 'Total price', width: 30, hidden: false, editor: 'numeric', type: GridFieldType.Currency }
        ];

        if (this.totalMarginFlag) {
            this.gridColumns.push({ field: 'totalMargin', title: 'Total margin', width: 30, hidden: false, editor: 'numeric', type: GridFieldType.Percentage });
        }

        if (this.totalCostFlag) {
            this.gridColumns.push({ field: 'totalCost', title: 'Total cost', width: 30, hidden: false, editor: 'numeric', type: GridFieldType.Currency });
        }
    }
    // CALLOFFORDER GRID END
    // CALLOFFORDER CARD START
    generateCardModelForCallofforders(type: string) {
        this.cardColumns = [
            { field: 'description', isTitle: true, displayName: '', icon: '' },
            { field: 'productCode', displayName: 'Prod. Code', icon: '' },
            { field: 'lineNumber', displayName: 'Line', icon: '' },
            { field: 'quantity', displayName: 'Quantity', icon: '', isNumericWithCode: true },
            { field: 'quantityCalledOff', displayName: 'Called off', icon: '', isNumericWithCode: true },
            { field: 'unitSellPrice', displayName: 'Sell price', icon: '', isCurrencyWithCode: true },
            { field: 'totalSellPrice', displayName: 'Total price', icon: '', isCurrency: true }
        ];

        if (this.totalMarginFlag) {
            this.cardColumns.push({ field: 'totalMargin', displayName: 'Total margin', icon: '', isPercentage: true });
        }

        if (this.totalCostFlag) {
            this.cardColumns.push({ field: 'totalCost', displayName: 'Total cost', icon: '', isCurrency: true });
        }
    }

    // For Lines GridModel
    generateGridModelForInvoiceAndCredit(type: string) {
        this.gridColumns = [
            { field: 'description', title: 'Product Description', width: 30, hidden: false },
            { field: 'productCode', title: 'Prod. Code', width: 30, hidden: false },
            { field: 'lineNumber', title: 'Line', width: 30, hidden: false },
            { field: 'quantity', title: 'Quantity', width: 30, hidden: false, editor: 'numeric', type: GridFieldType.NumericWithCode },
            { field: 'price', title: 'Sell price', width: 30, hidden: false, editor: 'numeric', type: GridFieldType.CurrencyWithCode },
            { field: 'total', title: 'Total price', width: 30, hidden: false, editor: 'numeric', type: GridFieldType.Currency }
        ];

        if (type == DocumentTypes.Invoices) {
            if (this.totalMarginFlag) {
                this.gridColumns.push({ field: 'totalMargin', title: 'Total margin', width: 30, hidden: false, editor: 'numeric', type: GridFieldType.Percentage });
            }

            if (this.totalCostFlag) {
                this.gridColumns.push({ field: 'totalCost', title: 'Total cost', width: 30, hidden: false, editor: 'numeric', type: GridFieldType.Currency });
            }
        } else {
            this.gridColumns.push({ field: 'totalMargin', title: 'Total margin', width: 30, hidden: false, editor: 'numeric', type: GridFieldType.Percentage },
                { field: 'totalCost', title: 'Total cost', width: 30, hidden: false, editor: 'numeric', type: GridFieldType.Currency });
        }
    }

    // For Lines CardModel
    generateCardModelForInvoiceAndCredit(type: string) {
        this.cardColumns = [
            { field: 'description', isTitle: true, displayName: '', icon: '' },
            { field: 'productCode', displayName: 'Prod. Code', icon: '' },
            { field: 'lineNumber', displayName: 'Line', icon: '' },
            { field: 'quantity', displayName: 'Quantity', icon: '', isNumericWithCode: true },
            { field: 'price', displayName: 'Sell price', icon: '', isCurrencyWithCode: true },
            { field: 'total', displayName: 'Total price', icon: '', isCurrency: true }
        ];

        if (type == DocumentTypes.Invoices) {
            if (this.totalMarginFlag) {
                this.cardColumns.push({ field: 'totalMargin', displayName: 'Total margin', icon: '', isPercentage: true });
            }

            if (this.totalCostFlag) {
                this.cardColumns.push({ field: 'totalCost', displayName: 'Total cost', icon: '', isCurrency: true });
            }
        } else {
            this.cardColumns.push({ field: 'totalMargin', displayName: 'Total margin', icon: '', isPercentage: true },
            { field: 'totalCost', displayName: 'Total cost', icon: '', isCurrency: true });
        }
    }

    // CALLOFFORDER CARD END

    // PRODUCT-PURCHASED-BY GRID START

    generateGridModelForProductPurchasedBy(type: string) {
        this.gridColumns = [
            { field: 'description', title: 'Description', width: 30, hidden: false },
            { field: 'productCode', title: 'Prod. Code', width: 30, hidden: false },
            { field: 'lineNumber', title: 'Line', width: 30, hidden: false },
            { field: 'quantity', title: 'Quantity', width: 30, hidden: false, editor: 'numeric', type: GridFieldType.NumericWithCode },
            { field: 'quantityTally', title: 'Tally', width: 30, hidden: false, editor: 'numeric' },
            { field: 'unitSellPrice', title: 'Sell price', width: 30, hidden: false, editor: 'numeric', type: GridFieldType.CurrencyWithCode },
            { field: 'totalSellPrice', title: 'Total price', width: 30, hidden: false, editor: 'numeric', type: GridFieldType.Currency },
            { field: 'totalMargin', title: 'Total margin', width: 30, hidden: false, editor: 'numeric', type: GridFieldType.Percentage },
            { field: 'totalCost', title: 'Total cost', width: 30, hidden: false, editor: 'numeric', type: GridFieldType.Currency }
        ];
    }

    // PRODUCT-PURCHASED-BY GRID END
    // PRODUCT-PURCHASED-BY CARD START
    generateCardModelForProductPurchasedBy(type: string) {
        this.cardColumns = [
            { field: 'description', isTitle: true, displayName: '', icon: '' },
            { field: 'productCode', displayName: 'Prod. Code', icon: '' },
            { field: 'lineNumber', displayName: 'Line', icon: '' },
            { field: 'quantity', displayName: 'Quantity', icon: '', isNumericWithCode: true },
            { field: 'quantityTally', displayName: 'Tally', icon: '' },
            { field: 'unitSellPrice', displayName: 'Sell price', icon: '', isCurrencyWithCode: true },
            { field: 'totalSellPrice', displayName: 'Total price', icon: '', isCurrency: true },
            { field: 'totalMargin', displayName: 'Total margin', icon: '', isPercentage: true },
            { field: 'totalCost', displayName: 'Total cost', icon: '', isCurrency: true }
        ];

    }


    // STOCKTRANSFERS MODEL(MAPPING) START
    getDetailsModelForStock(selectedItem: any, selectedItemDetails: any): DocumentDetailModel {
        this.documentDetail = new DocumentDetailModel();
        this.documentDetail.type = 'StockTransfer';
        this.documentDetail.orderNumber = selectedItem.orderNumber;
        this.documentDetail.id = selectedItem.orderId;
        this.documentDetail.customerID = selectedItem.customerID;
        this.documentDetail.customerCode = selectedItem.customerCode;
        // this.documentDetail.customerName = selectedItem.customer.name;
        // this.documentDetail.name = selectedItem.customer.name;
        this.documentDetail.status = selectedItem.orderStatus;
        this.documentDetail.statusName = selectedItemDetails.orderStatus;
        this.documentDetail.jobRef = selectedItem.jobRef;
        // this.documentDetail.expiryDate = selectedItem.expiryDate;
        this.documentDetail.createdDate = selectedItemDetails.dateTimeCreated;
        this.documentDetail.requiredDate = selectedItemDetails.dateRequired;
        this.documentDetail.branchID = selectedItem.branchId;
        this.documentDetail.branchName = selectedItem.branchName;
        this.documentDetail.tobranchName = selectedItem.toBranchName;
        this.documentDetail.viabranchName = selectedItem.viaBranchName;
        this.documentDetail.createdBy = selectedItem.createdBy;
        // this.documentDetail.currencyCode = selectedItemDetails.currencyCode;
        // this.documentDetail.goodsTotal = selectedItemDetails.totalSellPrice;
        // this.documentDetail.vatTax = selectedItemDetails.totalVat;
        // this.documentDetail.totalAmount = selectedItemDetails.totalAmount;
        // this.documentDetail.totalMargin = selectedItemDetails.totalMargin;
        // this.documentDetail.totalCost = selectedItemDetails.totalCost;
        // this.documentDetail.specOrder = selectedItemDetails.hasSpecialProducts;
        // this.documentDetail.specOrderDesc = selectedItemDetails.hasSpecialProductsDescription;
        this.documentDetail.noOfLines = selectedItemDetails.noOfLines;
        // this.documentDetail.salesRepName = selectedItemDetails.salesRepName;
        // this.documentDetail.contactName = selectedItemDetails.contactName;
        // this.documentDetail.contactNumber = selectedItemDetails.contactNumber;
        // this.documentDetail.deliveryAddressCode = selectedItemDetails.deliveryAddressCode;
        // this.documentDetail.deliveryAddress = selectedItemDetails.deliveryAddress;
        // this.documentDetail.invoiceAddressCode = selectedItemDetails.invoiceAddressCode;
        // this.documentDetail.invoiceAddress = selectedItemDetails.invoiceAddress;
        this.documentDetail.lines = [];
        selectedItemDetails.lines.forEach(element => {
            if (element.lineType == 3 || element.lineType == 5) {
                element.quantity = null;
            }
            if (element.lineType == 5) {
                element.productCode = null;
            }

            this.documentDetail.lines.push(element);
        });
        // this.documentDetail.lines = selectedItemDetails.lines;
        return this.documentDetail;
    }

    // STOCKTRANSFERS GRID START
    generateGridModelForStocktransfers(type: string) {
        this.gridColumns = [
            { field: 'description', title: 'Description', width: 30, hidden: false },
            { field: 'productCode', title: 'Prod. Code', width: 30, hidden: false },
            { field: 'lineNumber', title: 'Line', width: 30, hidden: false },
            { field: 'quantity', title: 'Quantity', width: 30, hidden: false, type: GridFieldType.NumericWithCode }
        ];
    }
    // STOCKTRANSFERS GRID END

    // STOCKTRANSFERS CARD START
    generateCardModelForStocktransfers(type: string) {
        this.cardColumns = [
            { field: 'description', isTitle: true, displayName: '', icon: '' },
            { field: 'productCode', displayName: 'Prod. Code', icon: '' },
            { field: 'lineNumber', displayName: 'Line', icon: '' },
            { field: 'quantity', displayName: 'Quantity', icon: '', isNumericWithCode: true }
        ];

    }
    // STOCKTRANSFERS CARD END

    // PURCHASEORDERS MODEL(MAPPING) START
    getDetailsModelForPurchase(selectedItem: any, selectedItemDetails: any): DocumentDetailModel {
        this.documentDetail = new DocumentDetailModel();
        this.documentDetail.type = 'PurchaseOrder';
        this.documentDetail.orderType = selectedItem.orderType;
        this.documentDetail.orderNumber = selectedItem.purchaseOrderNumber;
        this.documentDetail.id = selectedItem.purchaseOrderID;
        this.documentDetail.dateExpected = selectedItem.dateExpected;
        this.documentDetail.status = selectedItem.statusName;
        this.documentDetail.requiredDate = selectedItem.dateRequired;
        this.documentDetail.branchID = selectedItem.branchID;
        this.documentDetail.branchCode = selectedItem.branchCode;
        this.documentDetail.branchName = selectedItem.branchName;
        this.documentDetail.supplier = selectedItem.supplierName;
        this.documentDetail.totalCost = selectedItem.totalCostPrice;
        this.documentDetail.totalAdditionalCost = selectedItem.totalAdditionalCost;
        this.documentDetail.totalWeight = selectedItem.totalWeight;
        this.documentDetail.createdBy = selectedItem.createdByName;
        this.documentDetail.createdByContactNumber = selectedItem.createdByContactNumber;
        this.documentDetail.approvedByNumber = selectedItem.approvedByContactNumber;
        this.documentDetail.approvedByName = selectedItem.approvedByName;
        this.documentDetail.deliveryAddressCode = selectedItem.deliveryAddressID;
        this.documentDetail.deliveryAddress = selectedItem.deliveryAddress;
        this.documentDetail.invoiceAddressCode = selectedItem.paymentAddressID;
        this.documentDetail.invoiceAddress = selectedItem.paymentAddress;
        this.documentDetail.noOfLines = selectedItem.noOfLines;
        this.documentDetail.lines = [];
        const newObject = new EpbtFaPurchaseOrderLines();
        selectedItemDetails.forEach(x => {
            if (x.lineType == 'ProductLine') {
                // Common Values
                newObject.description = x.description;
                newObject.lineNumber = x.lineNumber;

                // Manual Line Values
                newObject.manualCode = '';
                newObject.manualValueTypeDescription = '';
                newObject.manualValue = null;
                newObject.totalCostPrice = null;
            }
            if (x.lineType == 'ManualLine') {
                // Common Values
                newObject.description = x.description;
                newObject.lineNumber = x.lineNumber;

                // Manual Line Values
                newObject.manualCode = x.manualCode;
                newObject.manualValueTypeDescription = x.manualValueTypeDescription;
                newObject.manualValue = x.manualValue;
                newObject.totalCostPrice = x.totalCostPrice;

                // Product Line Values
                newObject.productCode = '';
                newObject.quantity = '';
                newObject.unitCostPrice = '';
            }
            if (x.lineType == 'TextLine') {
                // Common Values
                newObject.description = x.description;
                newObject.lineNumber = x.lineNumber;

                // Product Line Values
                newObject.productCode = '';
                newObject.quantity = '';
                newObject.unitCostPrice = '';

                // Manual Line Values
                newObject.manualCode = '';
                newObject.manualValueTypeDescription = '';
                newObject.manualValue = null;
                newObject.totalCostPrice = null;
            }
            this.documentDetail.lines.push(x);
        });
        return this.documentDetail;
    }


    // PurchaseOrders GRID START

    generateGridModelForPurchaseOrders(type: string) {

        this.gridColumns = [
            { field: 'description', title: 'Description', width: 30, hidden: false }];

        if (this.documentDetail.lines.find(x => x.lineType == 'ManualLine')) {
            this.gridColumns.push(
                { field: 'manualCode', title: 'Charge code', width: 30, hidden: false },
                { field: 'manualValueTypeDescription', title: 'Value type', width: 30, hidden: false },
                { field: 'manualValue', title: 'Value', width: 30, hidden: false, editor: 'numeric', type: GridFieldType.CurrencyWithCode },
                { field: 'totalCostPrice', title: 'Cost price', width: 30, hidden: false, editor: 'numeric', type: GridFieldType.Currency },
            );
        }

        if (this.documentDetail.lines.find(x => x.lineType == 'ProductLine')) {
            this.gridColumns.push(
                { field: 'productCode', width: 30, title: 'Prod. Code', icon: '' },
                { field: 'quantity', width: 30, title: 'Quantity', editor: 'numeric', type: GridFieldType.NumericWithCode },
                { field: 'unitCostPrice', width: 30, title: 'Unit Cost', editor: 'numeric', type: GridFieldType.CurrencyWithCode },
                { field: 'totalCostPrice', width: 30, title: 'Total cost', editor: 'numeric', type: GridFieldType.Currency },
            );
        }

        this.gridColumns.push(
            { field: 'lineNumber', title: 'Line', width: 30, hidden: false }
        );
    }

    // PurchaseOrders GRID END
    // PurchaseOrders CARD START
    generateCardModelForPurchaseOrders(type: string) {
        this.cardColumns = [
            { field: 'description', isTitle: true, displayName: '', icon: '' }
        ];
        if (this.documentDetail.lines.find(x => x.lineType == 'ProductLine')) {
            this.gridColumns.push(
                { field: 'productCode', width: 30, title: 'Prod. Code', icon: '' },
                { field: 'quantity', width: 30, title: 'Quantity', editor: 'numeric', type: GridFieldType.NumericWithCode },
                { field: 'unitCostPrice', width: 30, title: 'Unit Cost', editor: 'numeric', type: GridFieldType.CurrencyWithCode },
                { field: 'totalCostPrice', width: 30, title: 'Total cost', editor: 'numeric', type: GridFieldType.Currency },
            );
        }
        if (this.documentDetail.lines.find(x => x.lineType == 'ManualLine')) {
            this.gridColumns.push(
                { field: 'manualCode', title: 'Charge code', width: 30, hidden: false },
                { field: 'manualValueTypeDescription', title: 'Value type', width: 30, hidden: false },
                { field: 'manualValue', title: 'Value', width: 30, hidden: false, editor: 'numeric', type: GridFieldType.CurrencyWithCode },
                { field: 'totalCostPrice', title: 'Cost price', width: 30, hidden: false, editor: 'numeric', type: GridFieldType.Currency },
            );
        }
        this.cardColumns.push(
            { field: 'lineNumber', displayName: 'Line', icon: '' }
        );
    }
    // PurchaseOrders CARD END inputPerCode


}
